import api from '../api';

export default {
    namespaced: true,
    state: {
        packages: [],
        products: [],
        propertyTypes: [],
        qualifiers: [],
        tenures: [],
        buyerPositions: [],
        financialPositions: [],
        mortgageLeads: [],
        minimumTerms: [],
        furnishings: []
    },
    mutations: {
        setPackages(state, value) {
            state.packages = value;
        },
        setProducts(state, value) {
            state.products = value;
        },
        setProductTypes(state, value) {
            state.propertyTypes = value;
        },
        setQualifiers(state, value) {
            state.qualifiers = value;
        },
        setTenures(state, value) {
            state.tenures = value;
        },
        setBuyerPositions(state, value) {
            state.buyerPositions = value;
        },
        setFinancialPositions(state, value) {
            state.financialPositions = value;
        },
        setMortgageLeads(state, value) {
            state.mortgageLeads = value;
        },
        setMinimumTerms(state, value) {
            state.minimumTerms = value;
        },
        setFurnishings(state, value) {
            state.furnishings = value;
        }
    },
    getters: {

    },
    actions: {
        get({ commit }) {
            return api.get('global/config')
                .then(({ data }) => {
                    commit('setPackages', data.payload.packages);
                    commit('setProducts', data.payload.products);
                    commit('setProductTypes', data.payload.property_types);
                    commit('setQualifiers', data.payload.qualifiers);
                    commit('setTenures', data.payload.tenures);
                    commit('setBuyerPositions', data.payload.buyer_positions);
                    commit('setFinancialPositions', data.payload.financial_positions);
                    commit('setMortgageLeads', data.payload.mortgage_leads);
                    commit('setMinimumTerms', data.payload.minimum_terms);
                    commit('setFurnishings', data.payload.furnishings);
                })
                .catch((error) => {

                });
        }
    }
};
